import React from 'react';
import { Link } from 'react-router-dom';

export default props => (
  <div className="list-group">
    {props.orders.map(order => (
      <Link
        key={order.id}
        to={order.url}
        className="list-group-item list-group-item-action"
      >
        <strong>{order.property}</strong> - <em>{order.borrower}</em>
      </Link>
    ))}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/orders/OrderGroupList.js